import React, { useState, useContext, useEffect } from "react";
import "./About.css";
import BackgroundSlider from "../../BackGround/BackgroundSlider";
import Logo from "../../../images/Logo.png";
import { InputField } from "../Reuseable/InputField";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RegisterContext from "../../../../createContext/Register/RegisterContext";
import { useNavigate } from "react-router-dom";

const Backend_URL = process.env.REACT_APP_BACKEND_URL;

function About() {
  const navigate = useNavigate();
  const { aboutForm, loading } = useContext(RegisterContext);
  const [formData, setFormData] = useState(() => {
    const savedData = sessionStorage.getItem("formData");
    return savedData
      ? JSON.parse(savedData)
      : {
          userName: "",
          name: "",
          age: "",
          gender: "",
          location: "",
          industry: "",
          bio: "", 
        };
  });

  const [isUserNameAvailable, setIsUserNameAvailable] = useState(true);
  const [checkingUserName, setCheckingUserName] = useState(false);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "userName") {
      setCheckingUserName(true);
      const token = localStorage.getItem("token");

      try {
        const response = await fetch(
          `${Backend_URL}/api/check-username?userName=${value}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              token,
            },
          }
        );
        const data = await response.json();
        setIsUserNameAvailable(data.isAvailable);
      } catch (error) {
        toast.error("An error occurred while checking the username.");
      } finally {
        setCheckingUserName(false);
      }
    }
  };

  const validateForm = () => {
    let isValid = true;

    if (!formData.userName.trim()) {
      toast.error("Username is required.");
      isValid = false;
    } else if (!isUserNameAvailable) {
      toast.error("Username is already taken.");
      isValid = false;
    }

    if (!formData.name.trim()) {
      toast.error("Full Name is required.");
      isValid = false;
    }

    if (!formData.location.trim()) {
      toast.error("Location is required.");
      isValid = false;
    }

    if (formData.age && (formData.age < 18 || formData.age > 100)) {
      toast.error("Age must be between 18 and 100.");
      isValid = false;
    }

    if (
      formData.gender &&
      !["male", "female", "other"].includes(formData.gender)
    ) {
      toast.error("Please select a valid gender.");
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const response = await aboutForm(formData);

        if (response.success) {
          localStorage.removeItem("isRegistered");
          navigate("/register/passion");
        } else {
          toast.error(response.message || "Something went wrong.");
        }
      } catch (err) {
        toast.error("An error occurred during registration.");
      }
    }
  };

  const inputFields = [
    {
      label: "Username",
      name: "userName",
      type: "text",
      placeholder: "Enter your username",
      required: true,
    },
    {
      label: "Full Name",
      name: "name",
      type: "text",
      placeholder: "Enter your name",
      required: true,
    },
    {
      label: "Age (Optional)",
      name: "age",
      type: "number",
      placeholder: "Enter your age",
      required: false,
    },
    {
      label: "Gender (Optional)",
      name: "gender",
      type: "select",
      options: ["male", "female", "other"],
      required: false,
    },
    {
      label: "Location",
      name: "location",
      type: "text",
      placeholder: "Enter your location",
      required: true,
    },
    {
      label: "Industry (Optional)",
      name: "industry",
      type: "select",
      options: [
        "Technology",
        "Banking and Financial Services",
        "Consulting",
        "Insurance",
        "Government",
        "Legal Services",
        "Hospitality",
        "Airlines and Aviation",
        "Healthcare",
        "Engineering",
        "Education",
        "Non-Profit",
        "Media",
        "Defense",
        "Manufacturing",
        "Farming",
        "Human Resources",
        "Finance",
        "Supply Chain",
        "Customer Service",
        "Marketing and Advertising",
        "Sales",
      ],
      required: true,
    },
    {
      label: "Bio (Optional)",
      name: "bio",
      type: "textarea",
      placeholder: "Write a short bio about yourself",
      required: false,
    },
  ];

  useEffect(() => {
    sessionStorage.setItem("formData", JSON.stringify(formData));
  }, [formData]);
  return (
    <>
      <div className="Aboutheader">
        <img src={Logo} alt="Fisko" className="Logo" />
      </div>
      <div className="about-page">
        <BackgroundSlider />
        <div className="about-box">
          <main className="aboutContainer">
            <header className="AboutheaderSection">
              <h1 className="title">Tell Us About Yourself</h1>
              <h2 className="subtitle">Complete your profile to get started</h2>
            </header>

            <form onSubmit={handleSubmit} style={{ width: "65%" }}>
              {inputFields.map((field, index) => (
                <div key={index} className="inputGroup">
                  {field.type === "select" ? (
                    <>
                      <label
                        htmlFor={field.name}
                        className="inputLabel"
                        style={{ marginLeft: "0px" }}
                      >
                        {field.label}
                      </label>
                      <select
                        name={field.name}
                        id={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                        className="inputField"
                      >
                        <option value="" disabled>
                          Select your {field.label.toLowerCase()}
                        </option>
                        {field.options.map((option, idx) => (
                          <option key={idx} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </>
                  ) : (
                    <InputField
                      label={<span>{field.label}</span>}
                      placeholder={field.placeholder}
                      type={field.type}
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                  )}
                </div>
              ))}

              {/* Submit Button */}
              <button type="submit" className="submitButton" disabled={loading}>
                {loading ? "Saving..." : "Save Details"}
              </button>
            </form>
          </main>
        </div>
      </div>

      {/* Toast container for showing success/error messages */}
      <ToastContainer />
    </>
  );
}

export default About;
